import React from 'react';
import { Routes, Route } from 'react-router-dom';
import StockPage from './StockPage';
import StockItemEditPage from './StockItemEditPage';
import StorageLocationsPage from './StorageLocationsPage';
import PrepareWeekPage from './PrepareWeekPage';

/** Pages under /casa/em-casa. */
const PantryRoutes: React.FC = () => (
  <Routes>
    <Route index element={<StockPage />} />
    <Route path="locais" element={<StorageLocationsPage />} />
    <Route path="preparar" element={<PrepareWeekPage />} />
    <Route path="novo" element={<StockItemEditPage />} />
    <Route path=":itemId" element={<StockItemEditPage />} />
  </Routes>
);

export default PantryRoutes;
